<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 20px auto 0px 15px"
    ></toolbar>
    <!--   <el-select v-model="status" @change="changeStatus" placeholder="请选择状态">
                  <el-option label="待审核" value="1"></el-option>
                  <el-option label="审核通过" value="2"></el-option>
                  <el-option label="驳回" value="3"></el-option>
      </el-select>-->
    <!--列表-->
    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Id"
        label="ID"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CateName"
        label="分类"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="QuestionTitle"
        label="问题"
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!-- <el-table-column
          prop="Status"
          label="是否发布"
          width="150"
          align="center"
          
        >
          <template slot-scope="scope">
            {{ scope.row.Status == 2 ? "已发" : "未发" }}
          </template></el-table-column
        > -->
      <el-table-column
        prop="QuestionTypeName"
        label="问题类型"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column prop="Img" label="封面" width="100" align="center">
        <template slot-scope="scope">
          <div>
            <el-image
              :src="scope.row.QuestionImg"
              fit="contain"
              @click.native="Logimg.push(scope.row.QuestionImg)"
            >
            </el-image>
          </div>
        </template>
      </el-table-column>
      <!-- :formatter="formatCreateTime" -->
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        align="center"
      ></el-table-column>
      <el-table-column label="状态" align="center" width="80">
        <template slot-scope="scope">
          {{
            scope.row.Status == 1 || scope.row.Status == 3 ? "待开启" : "待终止"
          }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="onLookDatas(scope.row.Id)"
              >课程目录</el-button
            >
          </template>
        </el-table-column> -->
      <el-table-column label="操作" width align="center">
        <template slot-scope="scope">
          <span class="SpanList" @click="onLookDatas(scope.row.Id)"
            >查看评价</span
          >
          <span class="SpanList" @click="handleEdit(scope.row)">编辑</span>
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
          <span
            class="SpanList"
            @click="onClickOpenStatus(scope.row)"
            v-if="scope.row.Status == 1 || scope.row.Status == 3"
            >开启</span
          >
          <span
            class="SpanList"
            @click="onClickOpenStatus(scope.row)"
            v-if="scope.row.Status == 2"
            >终止</span
          >
          <!-- <span class="SpanList" v-if="scope.row.Status == 3">已终止</span> -->
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @opened="Editwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          编辑
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="分类" prop="CateId">
          <el-select v-model="editForm.CateId" placeholder="请选择分类">
            <el-option
              v-for="item in catelist"
              :key="item.Id"
              :label="item.CateName"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="问题" prop="QuestionTitle">
          <el-input
            v-model="editForm.QuestionTitle"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="QuestionType">
          <el-radio-group v-model="editForm.QuestionType" @change="radiochange">
            <el-radio :label="1">推文</el-radio>
            <el-radio :label="2">讨论</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action="/api/ImgUpload/UploadImg/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input
            type="int"
            v-model="editForm.OrderSort"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="详情" :hidden="contentstatus">
          <div class="edit_container" id="edit_container"></div>
          <!-- <quill-editor
              v-model="editForm.Content"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            ></quill-editor> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @opened="Addwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          新增
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="分类" prop="CateId">
          <el-select
            aria-required
            v-model="addForm.CateId"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in catelist"
              :key="item.Id"
              :label="item.CateName"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="问题" prop="QuestionTitle">
          <el-input
            v-model="addForm.QuestionTitle"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="QuestionType">
          <el-radio-group v-model="addForm.QuestionType" @change="radiochange">
            <el-radio :label="1">推文</el-radio>
            <el-radio :label="2">讨论</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action="/api/ImgUpload/UploadImg"
            :headers="headers"
            :show-file-list="false"
            width="380"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input
            type="int"
            v-model="addForm.OrderSort"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="详情" :hidden="contentstatus">
          <div class="edit_container" id="Add_container"></div>
          <!-- <quill-editor
              v-model="addForm.Content"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            ></quill-editor> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 开始的学生列表 -->
    <el-dialog
      title="开始的学生列表"
      :visible.sync="dialogVisibleStudent"
      width="30%"
    >
      <div>
        <el-form ref="form" :model="form">
          <el-form-item label="时间：">
            <el-date-picker
              v-model="form.value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="学生列表：">
            <el-cascader
              style="width: 400px"
              :options="options"
              :props="prop"
              clearable
              placeholder="请选择学生列表"
              @change="onChangeCascader"
              ref="cascaderArr"
            ></el-cascader>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleStudent = false">取 消</el-button>
        <el-button type="primary" @click="onClickSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
  
  <script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import store from "../../store";
import util from "../../../util/date";
import {
  GetCateListByPage,
  GetHotQuestionListByPage,
  QuestionInfoDelete,
  HotQuestionInfoUpdate,
  HotQuestionInfoAdd,
  UploadImg,
  StopQuestion,
  GetOptionGroup,
  OpenQuestionInfo,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import E from "wangeditor";
export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      editor: null,
      headers: {
        Authorization: "",
      },
      contentstatus: false,
      content: ``,
      editorOption: {},
      imageUrl: "",
      catelist: [],
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      //statusList: [{LinkUrl: '激活', value: true}, {LinkUrl: '禁用', value: false}],
      total: 0,
      page: 1,
      pagesize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CateId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        QuestionTitle: [
          { required: true, message: "请输入问题", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CateId: 0,
        Content: "",
        QuestionImg: "",
        OrderSort: 0,
        QuestionType: 1,
        QuestionTitle: "",
        Status: 1,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CateId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        QuestionTitle: [
          { required: true, message: "请输入问题", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        CateId: 0,
        Content: "",
        QuestionImg: "",
        OrderSort: 0,
        QuestionType: 1,
        QuestionTitle: "",
        Status: 1,
      },
      dialogVisibleStudent: false,
      prop: { multiple: true },
      options: [],
      form: {
        value1: [
          new Date(2000, 10, 10, 10, 10),
          new Date(2000, 10, 11, 10, 10),
        ],
        HopeJobProvinces: [],
        questionId: 0,
      },
    };
  },
  modules: {
    toolbar: {
      container: [
        //配置项，全部配置如上
        ["bold", "italic", "underline"],
        [{ align: [] }],
        ["image"],
      ],
      handlers: {
        image: function (value) {
          if (value) {
            document.querySelector(".avatar-uploader input").click();
          } else {
            this.quill.format("image", false);
          }
        },
      },
    },
  },
  // computed: {
  //   editor() {
  //     return this.$refs.myQuillEditor.quill;
  //   },
  // },
  methods: {
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    refreshData() {
      this.form = {
        value1: [
          new Date(2000, 10, 10, 10, 10),
          new Date(2000, 10, 11, 10, 10),
        ],
        HopeJobProvinces: [],
        questionId: 0,
      };
    },
    onChangeCascader(e) {
      const checkedNode = this.$refs["cascaderArr"].getCheckedNodes();
      this.form.HopeJobProvinces = checkedNode.map((cc) => cc.value);
    },
    async onClickSubmit() {
      let res = await OpenQuestionInfo({
        questionId: this.form.questionId,
        startTime: this.form.value1[0],
        endTime: this.form.value1[1],
        studentIds: this.form.HopeJobProvinces,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "开启成功",
        });
        this.getModules();
        this.refreshData();
        this.dialogVisibleStudent = false;
      } else {
        this.$message({
          type: "error",
          message: "开启失败",
        });
      }
      console.log(this.form.HopeJobProvinces);
      //   console.log();
    },
    async onClickOpenStatus(item) {
      if (item.Status == 2) {
        let res = await StopQuestion({
          Id: item.Id,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "终止成功",
          });
          this.getModules();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      } else {
        this.form.questionId = item.Id;
        this.GetOptionGroup();
        this.dialogVisibleStudent = true;
      }
    },
    async GetOptionGroup() {
      let res = await GetOptionGroup();
      if (res.data.success) {
        this.options = res.data.response;
      } else {
        this.options = [];
      }
    },
    DialogDown() {
      this.addFormVisible = false;
      this.editFormVisible = false;
    },
    // 查看数据
    onLookDatas(id) {
      //this.$router.push('/Course/courseData_index')

      this.$router.push({
        path: "/Question/Comment",
        query: { Id: id },
      });
    },
    Addwangeditor() {
      var c = document.getElementById("Add_container").innerHTML;
      //console.log(c);
      if (c.length <= 0) {
        console.log("chua");
        this.editor = new E("#Add_container");
        //this.editor.customConfig.debug = true;
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        //this.editor.txt.html(this.editForm.Content);
        this.editor.create();
        console.log(this.editor.txt.html());
      }
      if (c != null) {
        this.editor.txt.html("");
      }
    },
    Editwangeditor() {
      var c = document.getElementById("edit_container").innerHTML;
      //console.log(c);
      if (c.length <= 0) {
        console.log("chua");
        this.editor = new E("#edit_container");
        //this.editor.customConfig.debug = true;
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.txt.html(this.editForm.Content);
        this.editor.create();
      }
      if (this.editForm.Conten != "") {
        this.editor.txt.html(this.editForm.Content);
      }
    },
    radiochange(val) {
      if (val == 1) {
        this.contentstatus = false;
      } else {
        this.contentstatus = true;
      }
    },
    onEditorReady(editor) {}, // 准备编辑器
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    saveHtml(event) {
      alert(this.content);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.response;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadImg(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        this.addForm.QuestionImg = response.data.response;
        this.editForm.QuestionImg = response.data.response;
        this.imageUrl = response.data.response;
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:MM:ss"
          );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    // changeStatus(val){
    //     this.statusvalue=val;
    //     this.getModules();
    // },
    //获取分类
    getCateInfo() {
      let para = {
        Type: 2,
      };
      GetCateListByPage(para).then((res) => {
        this.catelist = res.data.response;
      });
    },
    //获取用户列表
    getModules() {
      let para = {
        PageIndex: this.page,
        PageSize: this.pagesize,
        Name: this.filters.name,
        Status: 0, //this.statusvalue
        Type: 2,
      };
      this.listLoading = true;

      //NProgress.start();
      GetHotQuestionListByPage(para).then((res) => {
        if (res.data.success) {
          this.AddRecordInfo("查询", "交流互动-互动话题管理-查看热门专题列表");

          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
          this.users = [];
          this.total = 0;
          this.listLoading = false;
        }
        //NProgress.done();
      });
    },
    //删除
    handleDel(id) {
      // let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要删除的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Id: id };
          QuestionInfoDelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.AddRecordInfo(
                "删除",
                "交流互动-互动话题管理-删除热门专题列表"
              );

              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(row) {
      //let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要编辑的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.imageUrl = this.editForm.QuestionImg;
      // if (this.editForm.QuestionType == 1) {
      //   this.contentstatus=false;
      // } else {
      //     this.contentstatus=true;
      // }
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        QuestionImg: "",
        QuestionType: 1,
      };
    },
    //编辑
    editSubmit: function () {
      this.editForm.Status = 1;
      this.editForm.Content = this.editor.txt.html();
      this.headers.Authorization = "Bearer " + store.state.token;
      this.$confirm("确认提交吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = Object.assign({}, this.editForm);
          para.QuestionImg = this.imageUrl;
          HotQuestionInfoUpdate(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "成功",
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getModules();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //新增
    addSubmit: function () {
      this.addForm.Content = this.editor.txt.html();
      this.addForm.Status = 1;
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.QuestionImg = this.imageUrl;
            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            HotQuestionInfoAdd(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.AddRecordInfo(
                  "新增",
                  "交流互动-互动话题管理-新增热门专题列表"
                );

                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getModules();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
  },
  mounted() {
    this.getModules();
    this.getCateInfo();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.headers.Authorization = "Bearer " + store.state.token;
  },
};
</script>
  
  <style lang="less">
.el-cascader-menu:nth-child(1) .el-checkbox {
  display: none;
}
.el-cascader-menu:nth-child(2) .el-checkbox {
  display: none;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}
.avatar {
  width: 320px;
  height: 180px;
  display: block;
}
</style>
  